
import { CustomTheme } from '@orijinworks/frontend-commons';

export default theme => ({
  locationName: {
    color: '#747474',
    letterSpacing: '1.25px',
    fontSize: 11,
    fontWeight: 700
  },
  tabName: {
    color: '#000000',
    letterSpacing: '0.15px',
    fontSize: 20,
    lineHeight: '24px',
    fontWeight: 500
  },
  btnNameLabel: {
    display: 'block',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
  },
  datatable: {
    '& td': {
      fontSize: 14,
      letterSpacing: '0.04px',
      color: '#000000'
    }
  },
  card: {
    borderRadius: 0,
    marginLeft: 30
  },
  reloadIcon: {
    color: CustomTheme.palette.primary.main
  },
  chip: {
    backgroundColor: '#d3d3d3',
    padding: '5px 10px',
    borderRadius: 3,
    marginLeft: 5
  },
  chipText: {
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: '#6f6f6f'
  },
  submissionText: {
    fontSize: 14,
    letterSpacing: '0.04px',
    fontWeight: 700,
    color: theme.palette.text.navy
  },
  formName: {
    fontSize: 18,
    textAlign: 'left',
    color: theme.palette.text.navy,
    letterSpacing: '0.43px',
    textTransform: 'capitalize'
  },
  permissionChipsWrap: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(0.5)
  },
  notApplicableText: {
    fontStyle: 'italic',
    color: theme.palette.text.secondary
  }
});
